import { render, staticRenderFns } from "./Busy.vue?vue&type=template&id=2cc1fb2d&"
import script from "./Busy.vue?vue&type=script&lang=js&"
export * from "./Busy.vue?vue&type=script&lang=js&"
import style0 from "./Busy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports